import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getTeamFeatures } from 'state/reducers/team/teamActions';
import Loading from 'views/components/Loading';
import ROUTE_PATHS from 'routes/routePaths';
import { getMe } from '../../../legacy/store/appReducer';

const homeStyle = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  height: '200px',
};

class Home extends React.PureComponent {
  UNSAFE_componentWillMount() {
    localStorage.setItem('scripload', false);
    this.props.dispatch(getTeamFeatures()).catch(err => console.log(err));
    this.props.dispatch(getMe()).catch(err => console.log(err));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { teamFeatures, history, app } = this.props;
    if (
      teamFeatures &&
      !teamFeatures.isFetching &&
      app &&
      !app.dataSources.me.isFetching
    ) {
      const referralEnabled =
        teamFeatures.referral && teamFeatures.referral.enabled;
      const rpmEnabled = teamFeatures.rpm && teamFeatures.rpm.enabled;
      const teleConnectEnabled =
        teamFeatures.teleconnect && teamFeatures.teleconnect.enabled;
      const serviceProviderEnabled =
        teamFeatures['qt-service-provider'] &&
        teamFeatures['qt-service-provider'].enabled;
      if (referralEnabled && !rpmEnabled) {
        window.location.href = '/recommend';
      } else if (serviceProviderEnabled) {
        window.location.href = '/qt-ekg-review';
      } else if (teleConnectEnabled) {
        if (
          (app.dataSources.me.data.profile.permissions.isAdmin &&
            app.dataSources.me.data.profile.permissions.isPhysician) ||
          app.dataSources.me.data.profile.permissions.isPhysician
        ) {
          history.push(ROUTE_PATHS.TELEKARDIA_DASHBOARD);
        } else {
          history.push(ROUTE_PATHS.TELEKARDIA_ADMIN_DASHBOARD);
        }
      } else {
        history.push(ROUTE_PATHS.DASHBOARD);
      }
    }
  }

  render() {
    return (
      <div style={homeStyle}>
        <Loading size="medium" />
      </div>
    );
  }
}

function mapStateToProps({ teamFeatures, app }) {
  return {
    teamFeatures,
    app,
  };
}

export default withRouter(connect(mapStateToProps)(Home));



// WEBPACK FOOTER //
// ./src/views/pages/Home/Home.jsx